import React, { useState } from "react";
import SectionTitle from "../common/section_title";
import styles from "./styles/admission.module.scss";

export const AdmissionTabs = () => {
  const [tab, setTab] = useState(1);
  return (
    <section className={styles.section_admission_tab}>
      <div className="container">
        <div className="sec_title_wrapper">
          <SectionTitle
            shadow_text="FIND YOUR NEXT HOME"
            title="Explore the Best Study Abroad Destinations"
            // shadow_text="COULD YOUR NEXT HOME BE?"
            // title="Explore Best Country"
          ></SectionTitle>
        </div>
      </div>
    </section>
  );
};

export default AdmissionTabs;
